'use strict'

import {attempt, isEmpty, isError} from 'lodash'

const FileSaver = require('file-saver')
const canvg = require('canvg-browser')
const emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/

const isJSON = (str) => {
  return !isError(attempt(JSON.parse, str))
}

const getCookie = (cname) => {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split('')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return null
}

const removeCookie = (cname) => {
  document.cookie = cname + '= expires=Thu, 01 Jan 1970 00:00:00 UTC path=/'
}

const operators = [
  { text: '=', value: 'OP_EQ' },
  { text: '!=', value: 'OP_NE' },
  { text: '>', value: 'OP_GT' },
  { text: '<', value: 'OP_LT' },
  { text: 'REGEXP', value: 'OP_MATCH' }
]

const roles = [
  { text: 'Administrateur', value: 'ROLE_ADMIN', level: 3 },
  { text: 'Invité', value: 'ROLE_GUEST', level: 2 },
  { text: 'Client', value: 'ROLE_USER', level: 1 },
  { text: 'Aucun', value: 'NONE', level: 0 }
]

const operatorText = (value) => {
  const op = operators.filter(op => op.value === value)
  return isEmpty(op) ? null : op[0].text
}
const operatorValue = (text) => {
  const op = operators.filter(op => op.text === text)
  return isEmpty(op) ? null : op[0].value
}

const roleText = (value) => {
  const role = roles.filter(role => role.value === value)
  return isEmpty(role) ? null : role[0].text
}
const roleObj = (value) => {
  return roles.filter(role => role.value === value)
}

const getRoleLevel = (roleName = 'ROLE_SHOP') => {
  let level = 0
  roles.forEach((role) => {
    if (role.value === roleName) {
      level = role.level
    }
  })
  return level
}

const checkRoleLevel = (roleInf = 'ROLE_SHOP', roleSup = 'ROLE_ADMIN') => {
  const lvInf = getRoleLevel(roleInf)
  const lvSup = getRoleLevel(roleSup)
  return lvInf >= lvSup
}

const dataURLtoFile = (dataurl, filename) => {
  var arr = dataurl.split(',')
  var mime = arr[0].match(/:(.*?)/)[1]
  var bstr = atob(arr[1])
  var n = bstr.length
  var u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new File([u8arr], filename, { type: mime })
}

const saveAsFile = (blob, fileName) => {
  FileSaver.saveAs(blob, fileName)
}

const getImageOption = (type = 'png') => {
  let option = 'image/png'
  if (type === 'jpeg') {
    option = 'image/jpeg'
  }
  return option
}

const saveAsImage = (chartContainer, type = 'png', fileName = 'file') => {
  const chartArea = chartContainer.getElementsByTagName('svg')[0].parentNode
  const svg = chartArea.innerHTML
  const doc = chartContainer.ownerDocument
  const canvas = doc.createElement('canvas')
  canvas.setAttribute('width', chartArea.offsetWidth)
  canvas.setAttribute('height', chartArea.offsetHeight)
  canvas.setAttribute(
    'style',
    'position: absolute ' +
    'top: ' +
    -chartArea.offsetHeight * 2 +
    'px' +
    'left: ' +
    -chartArea.offsetWidth * 2 +
    'px'
  )
  doc.body.appendChild(canvas)
  canvg(canvas, svg)
  const option = getImageOption(type)
  canvas.toBlob(blob => {
    fileName = fileName + '.' + type
    FileSaver.saveAs(blob, fileName)
  }, option)
  canvas.parentNode.removeChild(canvas)
}

export default {
  isJSON,
  operatorText,
  operatorValue,
  roleText,
  roleObj,
  roles,
  getCookie,
  removeCookie,
  dataURLtoFile,
  checkRoleLevel,
  saveAsFile,
  saveAsImage,
  getImageOption,
  emailRegex
}
